import { apiClient } from '../client';
import type { components } from '@aaimplatform/institutional-types/platform-admin-api';

/**
 * GET /admin/risk/summary, typed from the canonical contract
 * (schema-registry/platform-admin-api.openapi.yaml RiskSummaryResponse), which
 * platform-admin-api risk-dashboard.service.ts returns as the generated type.
 * The hand-written RiskSummary interface that stood here described the
 * service's older body and was deleted by name (ruling risk-summary-contest
 * (a)). Every list is required; a field the service did not measure (a
 * holding's exposure, ltv or rating, a stress probability, a gauge status) is
 * optional and omitted, and a list no engine produces arrives empty.
 */
export type RiskSummaryResponse = components['schemas']['RiskSummaryResponse'];

export const riskDashboardApi = {
  getSummary: async (): Promise<RiskSummaryResponse> => {
    return apiClient.get<RiskSummaryResponse>('/admin/risk/summary');
  },
};
